"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _helpers = _interopRequireDefault(require("../helpers"));
var _logger = _interopRequireDefault(require("../logger"));
var _signalr = require("@microsoft/signalr");
var _uuid = require("uuid");
var Core = exports["default"] = /*#__PURE__*/function () {
  function Core(appName, url) {
    (0, _classCallCheck2["default"])(this, Core);
    this.randomNumber = this.generateRandomString(5);
    this.appName = "".concat(appName, "-").concat(this.randomNumber);
    this.url = url || "http://127.0.0.1:5000/centralHub";
    this.connection = null;
    this.on = this.on.bind(this);
    this._events = {};
    this.cryptoKey = {};
    this.publicKey = "";
    this.services = {};
  }
  return (0, _createClass2["default"])(Core, [{
    key: "on",
    value: function on(event, callback) {
      var handlers = this._events[event] || [];
      handlers.push(callback);
      this._events[event] = handlers;
    }
  }, {
    key: "generateRandomString",
    value: function generateRandomString(length) {
      var result = '';
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }, {
    key: "trigger",
    value: function trigger(event, data) {
      var handlers = this._events[event];
      if (!handlers || handlers.length === 0) {
        return;
      }
      [].forEach.call(handlers, function (handler) {
        handler(data);
      });
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(message) {
      if (message.origin === 'sdk-' + this.appName) {
        // our messages shall be ignored
        return;
      }
    }
  }, {
    key: "deviceState",
    value: function deviceState() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        var payload = {
          uuid: uuid,
          requestUuid: "",
          action: "System.Relay.State",
          origin: "sdk-" + _this.appName,
          data: "{}"
        };
        _this.connection.invoke("messaging", payload).then(function () {
          _this.connection.on("messaging", function (msg) {
            if (msg.action === "System.Relay.State.Response" && msg.requestUuid === uuid) {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "getDisplayApplication",
    value: function getDisplayApplication() {
      var _this2 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        var payload = {
          uuid: uuid,
          requestUuid: "",
          action: "System.Relay.DisplayApplications",
          origin: "sdk-" + _this2.appName,
          data: "{}"
        };
        _this2.connection.invoke("messaging", payload).then(function () {
          _this2.connection.on("messaging", function (msg) {
            if (msg.action === "System.Relay.DisplayApplications.Response" && msg.requestUuid === uuid) {
              resolve(JSON.parse(msg.data));
            }
          });
        });
      });
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var exportedKey;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return crypto.subtle.generateKey({
                name: "RSA-OAEP",
                modulusLength: 2048,
                publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                hash: {
                  name: "SHA-256"
                }
              }, true, ["encrypt", "decrypt"]);
            case 2:
              this.cryptoKey = _context.sent;
              _context.next = 5;
              return crypto.subtle.exportKey("spki", this.cryptoKey.publicKey);
            case 5:
              exportedKey = _context.sent;
              this.publicKey = _helpers["default"].spkiToPEM(exportedKey);
              // Now, connect to LPSv2
              this.connection = new _signalr.HubConnectionBuilder().withUrl(this.url).withAutomaticReconnect().build();
              _context.next = 10;
              return this.connection.start({
                withCredentials: false
              });
            case 10:
              _logger["default"].info("Connection", "LPSv2 connected, sending ServiceNotification", "LPS");
              // Send to other modules that we are connected
              this.trigger('connection', true);
              this.connection.serverTimeoutInMilliseconds = 30000; // 30 second timeout
              this.connection.keepAliveIntervalInMilliseconds = 5000;
              // Handle 
              this.connection.on("messaging", this.handleMessage.bind(this));

              // Send a ServiceNotification to LPSv2
              _context.next = 17;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "System.ServiceNotification",
                requestUuid: "",
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 17:
              _logger["default"].info("ServiceNotification", "I've sent a ServiceNotification to LPSv2 containing my Public key", "LPS");
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  }]);
}();